import { debounce } from './global.js';

// Event delegation on `document` so this keeps working after the collection
// section is replaced wholesale by updateResults() — no per-instance re-binding.

function currentMain() {
  return document.querySelector('[data-collection-main]');
}

document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('[data-open-filters]');
  if (openBtn) document.getElementById('filters-drawer')?.open(openBtn);

  const viewBtn = e.target.closest('[data-view-columns]');
  if (viewBtn) setColumns(viewBtn.dataset.viewColumns);
});

document.addEventListener('change', (e) => {
  if (e.target.closest('[data-facet-input], [data-sort-select], [data-per-page-select]')) updateResults();
});

document.addEventListener(
  'input',
  debounce((e) => {
    if (e.target.closest('[data-price-range] input[type="number"]')) updateResults();
  }, 500)
);

document.addEventListener(
  'input',
  debounce((e) => {
    const slider = e.target.closest('[data-price-slider]');
    if (!slider) return;
    const wrap = slider.closest('[data-price-range]');
    const isMin = slider.dataset.priceSlider === 'min';
    const input = wrap.querySelector(isMin ? '#FilterPriceMin' : '#FilterPriceMax');
    if (input) input.value = slider.value;
    updateResults();
  }, 300)
);

function setColumns(cols) {
  const grid = currentMain()?.querySelector('[data-collection-grid]');
  if (!grid) return;
  document.querySelectorAll('[data-view-columns]').forEach((b) => {
    b.classList.toggle('is-active', b.dataset.viewColumns === cols);
    b.setAttribute('aria-pressed', b.dataset.viewColumns === cols);
  });
  grid.classList.toggle('product-grid--list', cols === 'list');
  if (cols !== 'list') grid.style.setProperty('--grid-columns-desktop', cols);
}

function buildParams() {
  const params = new URLSearchParams(window.location.search);
  const form = document.querySelector('[data-facet-form]');
  if (form) {
    Array.from(params.keys()).forEach((key) => {
      if (key.startsWith('filter.')) params.delete(key);
    });
    new FormData(form).forEach((value, key) => {
      if (value !== '') params.append(key, value);
    });
  }
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) params.set('sort_by', sortSelect.value);
  const perPageSelect = document.querySelector('[data-per-page-select]');
  if (perPageSelect) params.set('per_page', perPageSelect.value);
  params.delete('page');
  return params;
}

let requestToken = 0;

async function updateResults() {
  const mainEl = currentMain();
  if (!mainEl) return;
  const sectionId = mainEl.dataset.sectionId;
  const toolbar = document.querySelector('[data-collection-toolbar]');
  const token = ++requestToken;

  const params = buildParams();
  const pageUrl = `${window.location.pathname}?${params.toString()}`;
  const sectionUrl = `${window.location.pathname}?${params.toString()}&section_id=${sectionId}`;

  toolbar?.setAttribute('aria-busy', 'true');
  mainEl.classList.add('is-loading');

  try {
    const res = await fetch(sectionUrl);
    const html = await res.text();
    if (token !== requestToken) return; // a newer request superseded this one
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newMain = doc.querySelector('[data-collection-main]');
    if (newMain) {
      newMain.querySelectorAll('script').forEach((s) => s.remove());
      mainEl.replaceWith(newMain);
    }
    history.pushState({}, '', pageUrl);
  } finally {
    toolbar?.removeAttribute('aria-busy');
  }
}

window.addEventListener('popstate', () => window.location.reload());
